import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-LN/SafeDrivingTermsContents/.eu';

export interface SafeDrivingTermsContentsProps {
  vin: string;
}

export default function SafeDrivingTermsContents({vin}: SafeDrivingTermsContentsProps) {
  return (
    <>
      <Environment.Eu>
        <Environment.Kia>
          <Eu vin={vin} />
        </Environment.Kia>
      </Environment.Eu>
    </>
  );
}
